import React, { Component } from "react";
import { Collapse, NavbarBrand, NavbarToggler } from "reactstrap";
import { Link } from 'react-router-dom';
import {
    ProSidebar,
    Menu,
    MenuItem,
    SubMenu,
    SidebarHeader,
    SidebarContent,
    SidebarFooter
} from "react-pro-sidebar";
import { FaGem, FaList, FaGithub, FaCodiepie, FaBookReader } from "react-icons/fa";
import { AiFillHome } from "react-icons/ai";
import { RiShieldStarFill, RiFileList3Fill } from "react-icons/ri";
import UserCards from './UserCards';
import './SideBar.css';
import { AppContext } from './../AppContext';

const homepage = process.env.REACT_APP_EXP;

const styles = {
    sideBarHeight: {
        height: "100vh",
    },
    sidebarBgColor: {
        bgcolor: "#ffffff",
    },
}

const headerStyle = {
    padding: "24px",
    textTransform: "uppercase",
    fontWeight: "bold",
    letterSpacing: "1px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "noWrap"
};

const activeStyle = {    
    color: "#DFDFDF",
};

export class SideBar extends Component {

    constructor(props) {
        super(props);

        this.state = {
            iduser: 0,
            roles: [],
            activePage: '/',
            collapsed: this.props.collapse
        };

        this.handleActive = this.handleActive.bind(this);
        this.activeRoute.bind(this);
    }

    componentDidMount() {
        let id = 0;
        let currentUser = this.context
        if (currentUser != null) {
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
        }
        /*console.log("id", id);*/
    }

    componentDidUpdate() {
        let currentUser = this.context
        if (currentUser != null && this.state.iduser == 0) {
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
        }
    }

    handleActive(side) {
        if (!(side === this.state.activePage)) {
            this.setState({ activePage: side });
        }
    }

    activeRoute(routeName) {
        return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
    }
    /*765*/
    render() {
        return (
            <ProSidebar >
                <SidebarContent>
                    {this.state.collapsed ? <></> : < UserCards cedula={""} nombres={""} apellidos={""} user={""} />}
                    <Menu iconShape="circle" style={{ with: "20vw" }}>
                        <MenuItem active={window.location.pathname === homepage + "Inicio"} icon={<AiFillHome />} >{this.state.collapsed ? '' : 'Inicio'} <Link to={homepage + "Inicio"} onClick={() => this.handleActive(homepage + "Inicio")} /> </MenuItem>
                        <MenuItem active={window.location.pathname === homepage + "Reporte"} icon={<RiFileList3Fill />} >{this.state.collapsed ? '' : 'Certificados'} <Link to={homepage + "Reporte"} onClick={() => this.handleActive(homepage + "Reporte")} /> </MenuItem>
                        <MenuItem active={window.location.pathname === homepage + "Act-Est"} icon={<FaBookReader />} >{this.state.collapsed ? '' : 'Actividades'} <Link to={homepage + "Act-Est"} onClick={() => this.handleActive(homepage + "Act-Est")} /></MenuItem>
                        <MenuItem active={window.location.pathname === homepage + "Insignia"} icon={<RiShieldStarFill />} >{this.state.collapsed ? '' : 'Insignias'} <Link to={homepage + "Insignia"} onClick={() => this.handleActive(homepage + "Insignia")} /></MenuItem>
                        
                    </Menu>
                </SidebarContent>
            </ProSidebar>
        );
    }
    
}
SideBar.contextType = AppContext;
export default SideBar;